import React, { useState, useEffect } from "react";
import Lightbox from "react-image-lightbox";

import GalleryImage, { IProps as IImage } from "../../components/GalleryImage";
import LoadingSpinner from "../../components/LoadingSpinner";
import styles from "./styles.module.scss";
import "react-image-lightbox/style.css";
import "../../styles/App.scss";

export interface IServerImage extends IImage {
  category: string;
}

export interface ILightbox {
  activeImage: string;
  isOpen: boolean;
}

const Gallery: React.FC = () => {
  // TODO: Move to localstorage so images can be fetched and cached for entire session ...

  const [isLoading, setIsLoading] = useState(false);
  const [commercialPhotos, setCommercialPhotos] = useState<IServerImage[]>([]);
  const [ruralPhotos, setRuralPhotos] = useState<IServerImage[]>([]);
  const [residentialPhotos, setResidentialPhotos] = useState<IServerImage[]>(
    []
  );
  const [miscPhotos, setMiscPhotos] = useState<IServerImage[]>([]);
  const [lightbox, setLightbox] = useState<ILightbox>({
    activeImage: "",
    isOpen: false,
  });

  const fetchPhotos = async () => {
    const response = await fetch(
      "https://us-central1-mcptaupo-c15cb.cloudfunctions.net/fetchImages"
    );
    setIsLoading(false);

    const photos: IServerImage[] = await response.json();
    const sortedPhotos = new Map<string, IServerImage[]>(); // Should I sort these on the server? ...

    photos.forEach((photo) => {
      const updatedList = sortedPhotos.get(photo.category) || [];
      sortedPhotos.set(photo.category, [...updatedList, photo]);
    });

    // TODO: Could do a better job to streamline this process ...
    setCommercialPhotos(sortedPhotos.get("commercial") || []);
    setRuralPhotos(sortedPhotos.get("rural") || []);
    setResidentialPhotos(sortedPhotos.get("residential") || []);
    setMiscPhotos(sortedPhotos.get("misc") || []);
  };

  const handleImageClick = (url: string) => {
    if (url) {
      setLightbox({ ...lightbox, isOpen: true, activeImage: url });
    }
  };

  useEffect(() => {
    setIsLoading(true);
    fetchPhotos();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.pagetitle}>
        <h1>Gallery</h1>
        <p>Take a look at our past projects</p>
      </div>
      <h2>Commercial</h2>
      <div className={styles["photo-container"]}>
        {commercialPhotos.length ? (
          commercialPhotos.map((photo, index) => {
            return (
              <GalleryImage
                url={photo.url}
                thumbnailUrl={photo.thumbnailUrl}
                onClick={handleImageClick}
                alt={photo.alt}
                key={index}
              />
            );
          })
        ) : isLoading ? (
          <LoadingSpinner />
        ) : (
          <p>No images found</p>
        )}
      </div>
      <h2>Residential</h2>
      <div className={styles["photo-container"]}>
        {residentialPhotos.length ? (
          residentialPhotos.map((photo, index) => {
            return (
              <GalleryImage
                url={photo.url}
                thumbnailUrl={photo.thumbnailUrl}
                onClick={handleImageClick}
                alt={photo.alt}
                key={index}
              />
            );
          })
        ) : isLoading ? (
          <LoadingSpinner />
        ) : (
          <p>No images found</p>
        )}
      </div>
      <h2>Rural</h2>
      <div className={styles["photo-container"]}>
        {ruralPhotos.length ? (
          ruralPhotos.map((photo, index) => {
            return (
              <GalleryImage
                url={photo.url}
                thumbnailUrl={photo.thumbnailUrl}
                onClick={handleImageClick}
                alt={photo.alt}
                key={index}
              />
            );
          })
        ) : isLoading ? (
          <LoadingSpinner />
        ) : (
          <p>No images found</p>
        )}
      </div>
      <h2>Other projects</h2>
      <div className={styles["photo-container"]}>
        {miscPhotos.length ? (
          miscPhotos.map((photo, index) => {
            return (
              <GalleryImage
                url={photo.url}
                thumbnailUrl={photo.thumbnailUrl}
                onClick={handleImageClick}
                alt={photo.alt}
                key={index}
              />
            );
          })
        ) : isLoading ? (
          <LoadingSpinner />
        ) : (
          <p>No images found</p>
        )}
      </div>

      {lightbox.isOpen && (
        <Lightbox
          mainSrc={lightbox.activeImage}
          onCloseRequest={() => setLightbox({ ...lightbox, isOpen: false })}
        ></Lightbox>
      )}
    </div>
  );
};

export default Gallery;
